import { colors } from '@core/assistant/colors';

export const useStyles = () => {
  return {
    box: {
      width: 360,
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      background: colors.black_99,
      paddingTop: 2,
      paddingBottom: 3,
      paddingX: 2.5,
      borderRadius: 6,
      border: `1px solid ${colors.white_90}`,
      backdropFilter: 'blur(60px)',
      outline: 'none',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    button: {
      padding: 0,
      color: colors.grey_200,
      fontSize: 10,

      '& svg': {
        fontSize: 10,
        width: 18,
        height: 18,
      },
    },
  };
};
